"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createVirtualRef = void 0;
var _getBoundingClientRect = require("./getBoundingClientRect");
var createVirtualRef = function createVirtualRef(editor, at) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    fallbackRect = _ref.fallbackRect;
  return {
    current: {
      getBoundingClientRect: function getBoundingClientRect() {
        var rect = (0, _getBoundingClientRect.getBoundingClientRect)(editor, at) || fallbackRect;
        if (!rect) {
          throw new Error('Could not get the bounding client rect of the location. Please provide a fallbackRect.');
        }
        return rect;
      }
    }
  };
};
exports.createVirtualRef = createVirtualRef;